import { ButtonLeft } from '@zoopla-eng/zds-components/button';
import { FiltersMedium } from '@zoopla-eng/zds-components/icons';
import { FC, MouseEvent } from 'react';
import { desktopFiltersButtonStyle } from './Filters.styles.css';
import { FiltersModalProps } from './index';

enum LayoutVersion {
    Mobile = 'mobile',
    Desktop = 'desktop'
}

export type FiltersButtonProps = {
    onClick: (evt: MouseEvent<HTMLButtonElement>) => void;
    onKeyDown?: (evt: React.KeyboardEvent<HTMLButtonElement>) => void;
    onKeyUp?: (evt: React.KeyboardEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
} & Pick<FiltersModalProps, 'version'>;

const buttonCopy = 'Filters';
const defaultHandler = () => null;

export const FiltersButton: FC<React.PropsWithChildren<FiltersButtonProps>> = ({
    version,
    onClick,
    onKeyDown = defaultHandler,
    onKeyUp = defaultHandler,
    disabled = false
}) => {
    switch (version) {
        case LayoutVersion.Desktop:
            return (
                <div className={desktopFiltersButtonStyle}>
                    <ButtonLeft
                        disabled={disabled}
                        category="secondary"
                        onClick={onClick}
                        onKeyDown={onKeyDown}
                        onKeyUp={onKeyUp}
                        data-testid="search-results-header_filters-button"
                        Icon={FiltersMedium}
                    >
                        {buttonCopy}
                    </ButtonLeft>
                </div>
            );

        case LayoutVersion.Mobile:
            return (
                <ButtonLeft
                    disabled={disabled}
                    category="secondary"
                    onClick={onClick}
                    data-testid="mobile-sub-header_filters-button"
                    Icon={FiltersMedium}
                >
                    {buttonCopy}
                </ButtonLeft>
            );
        default:
            return null;
    }
};
